import React, { Component } from 'react';
import Header from '../../Header';

const url = "https://bikewale-login.onrender.com/api/auth/login";

class Login extends Component {

    constructor(props) {
        super(props)

        this.state = {
            email: '',
            password: '',
            message: ''
        }
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleSubmit = () => {
        fetch(url, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state)
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.auth === false) {
                    this.setState({ message: data.token })
                } else {
                    sessionStorage.setItem('ltk', data.token)
                    this.props.history.push('/')
                }
            })
    }

    render() {
        return (
            <>
                <Header />
                <div className="rounded d-flex justify-content-center">
                    <div className="col-md-4 col-sm-12 shadow-lg p-5 bg-light" style={{ width: '100%' }}>
                        <div className="text-center">
                            <h3 className="text-primary">Sign In</h3>
                        </div>
                        <div className="p-4">
                            <div className="input-group mb-3">
                                <span className="input-group-text bg-primary">
                                    <i className="fa-solid fa-envelope"></i>
                                </span>
                                <input className="form-control" name="email" value={this.state.email}
                                    onChange={this.handleChange} placeholder='abc@gmail.com'/>
                            </div>
                            <h2 style={{ color: 'red' }}>{this.state.message}</h2>
                            <div className="input-group mb-3">
                                <span className="input-group-text bg-primary">
                                    <i className="fa-solid fa-key"></i>
                                </span>
                                <input className="form-control" name="password" value={this.state.password}
                                    onChange={this.handleChange}  placeholder='*********'/>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" />
                                <label className="form-check-label" for="flexCheckDefault">
                                    Remember Me
                                </label>
                            </div>
                            <button className="btn btn-primary" onClick={this.handleSubmit}>
                                Login
                            </button>
                            <p className="text-center mt-5">Don't have an account?
                                <span className="text-primary">Sign Up</span>
                            </p>
                            <p className="text-center text-primary">Forgot your password?</p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default Login;